import Flatpickr from 'react-flatpickr';
import '@styles/react/libs/charts/apex-charts.scss';
import '@styles/react/libs/flatpickr/flatpickr.scss';
import moment from 'moment';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Controller } from 'react-hook-form';
import { Label } from 'reactstrap';
import classNames from 'classnames';

const DatePickerRange = ({
  id,
  name,
  label,
  error,
  control,
  placeholder,
  bottom
}) => {
  // ** State
  return (
    <div className={classNames('form-group', bottom ? 'mb-0' : 'mb-3')}>
      {label && <Label for={id}>{label}</Label>}
      <Controller
        control={control}
        id={id}
        name={name}
        render={({ field }) => (
          <Flatpickr
            {...field}
            placeholder={placeholder}
            className={classNames('form-control', {
              'is-invalid': !!error
            })}
            options={{
              mode: 'range',
              locale: Spanish,

              defaultDate: [
                moment(new Date(2022, 9, 1)).format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
              ]
            }}
          />
        )}
      />
      {error && (
        <span className="text-danger">
          <small>{error.message}</small>
        </span>
      )}
    </div>
  );
};

export default DatePickerRange;
